export default {
    namespaced: true,
    state: {
        isAuthenticated: false,
        authenticatedUser: "",
    },
    mutations: {
        SET_AUTH_STATUS: (state, authStatus) => {
          if (authStatus) {
            state.isAuthenticated = true;
          } else {
            state.isAuthenticated = false;
          }
        },
        SET_AUTH_USER: (state, authUser) => {
          state.authenticatedUser = authUser;
        }
      },
      actions: {
        setAuthStatus: ({ commit }, authStatus) => {
          commit("SET_AUTH_STATUS", authStatus);
        },
        setAuthUser: ({ commit }, authUser) => {
          commit("SET_AUTH_USER", authUser);
        }
      },
}